/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to rematch line items for specific room match groups
 * @export
 * @interface RematchLineItemsRequest
 */
export interface RematchLineItemsRequest {
    /**
     * Array of room match group IDs to rematch line items for
     * @type {Array<number>}
     * @memberof RematchLineItemsRequest
     */
    roomMatchGroupIds: Array<number>;
}

/**
 * Check if a given object implements the RematchLineItemsRequest interface.
 */
export function instanceOfRematchLineItemsRequest(value: object): value is RematchLineItemsRequest {
    if (!('roomMatchGroupIds' in value) || value['roomMatchGroupIds'] === undefined) return false;
    return true;
}

export function RematchLineItemsRequestFromJSON(json: any): RematchLineItemsRequest {
    return RematchLineItemsRequestFromJSONTyped(json, false);
}

export function RematchLineItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RematchLineItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roomMatchGroupIds': json['roomMatchGroupIds'],
    };
}

export function RematchLineItemsRequestToJSON(json: any): RematchLineItemsRequest {
    return RematchLineItemsRequestToJSONTyped(json, false);
}

export function RematchLineItemsRequestToJSONTyped(value?: RematchLineItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomMatchGroupIds': value['roomMatchGroupIds'],
    };
}

